import { toCurrency, toFormattedDate } from '@app/utilities';
import { Segment } from 'semantic-ui-react';
import { useCancelBNPL, useGetBNPLs } from '@app/sdk';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { Table } from '@app/shared';
import { useAccountIdContext } from '../AccountIdContext';
import { BNPL } from "@app/models";

export default function BNPLs() {
  const { accountId } = useAccountIdContext();

  const { data: bnpls, isLoading } = useGetBNPLs(accountId);

  const bnplColumnDef: ColDef[] = [
    {
      field: 'bnplId',
      headerName: 'Actions',
      minWidth: 250,
      cellRenderer: ActionButtons
    },
    { field: 'status', headerName: 'Status'},
    { field: 'type', headerName: 'Type'},
    { field: 'offerName', headerName: 'Offer Name'},
    { field: 'originalTerm', headerName: 'Original Term' },
    { field: 'remainingTerm', headerName: 'Remaining Term' },
    {
      field: 'originalAmount',
      headerName: 'Original Amount',
      valueFormatter: (params) => toCurrency(params?.value.value),
    },
    {
      field: 'createdDate',
      headerName: 'Created Date',
      valueFormatter: (params) => toFormattedDate(params?.value),
    },
    {
      field: 'expiryDate',
      headerName: 'Expiry Date',
      valueFormatter: (params) => toFormattedDate(params?.value),
    },
    {
      field: 'cancellationDate',
      headerName: 'Cancellation Date',
      valueFormatter: (params) => toFormattedDate(params?.value),
    },
    {
      field: 'expirationBusinessDate',
      headerName: 'Expiration Business Date',
      valueFormatter: (params) => toFormattedDate(params?.value),
    }
  ];

  return (
    <Segment style={{ height: '550px' }}>
      <h2>BNPLs</h2>
      {isLoading && <div className="ui active centered inline loader" />}
      {bnpls && (
        <div style={{ height: '450px' }}>
          <Table items={bnpls} columnDefs={bnplColumnDef} />
        </div>
      )}
    </Segment>
    
  );
}

function ActionButtons({ data, value }: ICellRendererParams<BNPL, string>) {
  const { mutateAsync: cancelBNPL, isPending: isCancellationPending } = useCancelBNPL();
  const { accountId } = useAccountIdContext();
  const isCancellationDisabled = data.status != "Active";

  const onCancelClicked = async () => {
    cancelBNPL({ accountId: accountId, subledgerId: value });
  };
 
  return (
    <>
      <button className={'ui button'} onClick={() => onCancelClicked()} disabled={isCancellationDisabled}>
        Cancel {isCancellationPending && <span className="ui active centered inline loader" />}
      </button>      
    </>
  );
}
